import { Component, inject, QueryList, ViewChildren } from '@angular/core';
import { CoreModule, FormComponent } from '@toevla-webapplications/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CampFormComponent } from '../camp-form/camp-form.component';
import { BookingService } from '../../../../../../services/booking/booking.service';

@Component({
    selector: 'ivva-booking-other-camps',
    templateUrl: './booking-other-camps.component.html',
    styleUrls: ['./booking-other-camps.component.scss'],
    imports: [ReactiveFormsModule, CoreModule, TranslateModule, CampFormComponent]
})
export class BookingOtherCampsComponent extends FormComponent {
	@ViewChildren(CampFormComponent)
	campForms: QueryList<CampFormComponent>;

	private readonly bookingService = inject(BookingService);

	override isFormValid(triggerErrors: boolean = true): boolean {
		const valids = this.campForms.map((cf) => cf.isFormValid(triggerErrors));
		return valids.every((v) => v);
	}

	override getFormData(): any {
		const data = this.bookingService.getCurrentBooking();
		const camps = data.camps!.filter((c) => c.priority === 1);

		const otherCamps = this.campForms.map((cf) => cf.getFormData());

		return {
			camps: [...camps, ...otherCamps],
		};
	}
}
